import React, { useEffect } from 'react';

interface MagazineFormModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  maxWidthClassName?: string;
}

const MagazineFormModal: React.FC<MagazineFormModalProps> = ({
  open,
  title,
  onClose,
  children,
  maxWidthClassName = 'max-w-2xl',
}) => {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-label="Close dialog"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="magazine-form-title"
        className={`relative z-10 flex w-full min-w-0 ${maxWidthClassName} max-h-[90vh] flex-col overflow-hidden rounded-xl bg-white shadow-2xl`}
      >
        <div className="flex shrink-0 items-center justify-between px-6 pt-6 pb-4">
          <h2 id="magazine-form-title" className="text-lg font-medium text-gray-800">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            aria-label="Close"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="min-w-0 overflow-y-auto px-6 pb-6 [&_form]:min-w-0 [&_input]:box-border [&_select]:box-border [&_textarea]:box-border [&_textarea]:max-w-full [&_textarea]:resize-y">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MagazineFormModal;
